import { providersReducer } from '../../../redux/resources/providers';

export const reducers = {
  providers: providersReducer,
};
